export interface DistributorData {
  id: string;
  company: {
    name: string;
    avatar: string;
    initial: string;
    bgColor: string;
  };
  country: string;
  contact: {
    initial: string;
    name: string;
    email: string;
    bgColor: string;
  };
  createdDate: string;
  lastActivity: string;
  contacts: number;
  deals: number;
  revenue: number;
}

export const mockDistributorsData: DistributorData[] = [
  {
    id: "1",
    company: {
      name: "HighGround (Direct)",
      avatar: "/avatar.png",
      initial: "H",
      bgColor: "violet",
    },
    country: "United Kingdom",
    contact: {
      initial: "M",
      name: "Mark Lamb",
      email: "mark.lamb@highground.com",
      bgColor: "violet",
    },
    createdDate: "12/01/24",
    lastActivity: "12/01/24 17:00",
    contacts: 5,
    deals: 100,
    revenue: 50,
  },
  {
    id: "2",
    company: {
      name: "Portland",
      avatar: "/image.png",
      initial: "P",
      bgColor: "orange",
    },
    country: "Netherlands",
    contact: {
      initial: "R",
      name: "Robin Smit",
      email: "robin.smit@portland.com",
      bgColor: "orange",
    },
    createdDate: "22/02/25",
    lastActivity: "12/11/24 17:00",
    contacts: 5,
    deals: 100,
    revenue: 50,
  },
  {
    id: "3",
    company: {
      name: "Brigantia",
      avatar: "/avatar-2.png",
      initial: "B",
      bgColor: "warning",
    },
    country: "United Kingdom",
    contact: {
      initial: "B",
      name: "Brigantia Tech",
      email: "hello@brigantia.com",
      bgColor: "warning",
    },
    createdDate: "22/02/25",
    lastActivity: "12/11/24 17:00",
    contacts: 5,
    deals: 100,
    revenue: 50,
  },
  {
    id: "4",
    company: {
      name: "Virosafe",
      avatar: "/avatar-3.png",
      initial: "V",
      bgColor: "success",
    },
    country: "Norway",
    contact: {
      initial: "I",
      name: "Ida Wirak",
      email: "ida.wirak@virosafe.com",
      bgColor: "success",
    },
    createdDate: "22/02/25",
    lastActivity: "12/11/24 17:00",
    contacts: 5,
    deals: 100,
    revenue: 50,
  },
];

